<html>
  <head>
    <link rel="stylesheet" href="navbar.component.css">
    <script href="navbar.component.ts"></script>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/css/materialize.min.css">
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
    <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css">
  </head>

  <body>
    <div class="bar fixed-element">
      <div class="row">
        <a [routerLink]="roleBasedLink">
          <img src="/assets/unipet_text.png" class="logo" height="50px" style="margin-top: 10px;">
        </a>

        <div class="right-side">
          <a href="faq"><i class="material-icons nav-icon">help_outline</i></a>
          <!-- Notification Button -->
          <button (click)="toggleNotifications($event)" class="notification-bell">
            <i class="material-icons nav-icon">notifications</i>
            <span *ngIf="hasUnreadNotifications()" class="notification-dot"></span>
          </button>                         
        </div>
      </div>
    </div>

    <!-- Overlay to detect outside clicks -->
  <div
    class="notification-overlay"
    *ngIf="showNotifications"
    (click)="closeNotifications()">
  </div>


  <!-- Notification Panel -->
  <div class="notification-panel" [class.active]="showNotifications">

    <div
      class="notification-content"
      [class.centered]="!loadingNotifications && notifications?.length === 0">
      <h5 style="color: #2aa570;"> Notifications </h5>

    <!-- Spinner shown when loading is true -->
    <div *ngIf="loadingNotifications" class="spinner-container">
      <div class="spinner"></div>
    </div>
    
      <p *ngIf="!loadingNotifications && notifications?.length === 0" class="empty-message">
        No new notifications.
      </p>

      <div *ngIf="!loadingNotifications">
        <div *ngFor="let noti of notifications" class="notification-item">
        <p class="notification-message">{{ noti.message }}</p>
        <div class="notification-meta">
          <p class="notification-date">{{ timeAgo(noti.createdAt) }}</p>
          <p class="notification-date">{{ formatDate(noti.createdAt) }}</p>
        </div>
      </div>
      </div>
    </div>
  </div>

    
  </body>
</html>
